import styled from 'styled-components';

import { NewStyleColor } from '../../../../utils/styles-constants';

const PopupBodyWrapper = styled('div')`
	padding-bottom: 10px;
`;

const Button = styled('button')`
	width: 100%;
	height: 50px;
	padding: 0;
	border: 0;
	outline: 0;
	font-family: HelveticaNeue, sans-serif;
	font-size: 14px;
	line-height: 50px;
	color: ${NewStyleColor.Black};
	text-align: center;
	background-color: ${NewStyleColor.White};
	cursor: pointer;

	&:not(:first-of-type) {
		border-top: 1px solid ${NewStyleColor.Grey300};
	}
`;

export {
	PopupBodyWrapper,
	Button,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Share/UprezForm/ShareActionPopup/styles.ts